// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__3dEGo","spinner":"Loader_spinner__2K4JZ"};